export default "__VITE_ASSET__BFJa01EZ__"